/* eslint-disable */
/*
====================================================
THIS IS AN AUTOGENERATED FILE
DO NOT EDIT. 
Update with `npm run graphql-codegen`
====================================================
*/
import * as Types from './types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInternalUserQueryVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['ID']>;
}>;


export type GetInternalUserQuery = { __typename?: 'Query', internalUser: { __typename?: 'InternalUser', id: string, displayName: string, email: string, roles: Array<{ __typename?: 'RoleType', normalizedId: string, name: string }>, preferredRole: { __typename?: 'RoleType', normalizedId: string, name: string } } };


export const GetInternalUserDocument = gql`
    query GetInternalUser($id: ID) {
  internalUser(id: $id) {
    id
    displayName
    email
    roles {
      normalizedId
      name
    }
    preferredRole {
      normalizedId
      name
    }
  }
}
    `;

/**
 * __useGetInternalUserQuery__
 *
 * To run a query within a React component, call `useGetInternalUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInternalUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInternalUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInternalUserQuery(baseOptions?: Apollo.QueryHookOptions<GetInternalUserQuery, GetInternalUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInternalUserQuery, GetInternalUserQueryVariables>(GetInternalUserDocument, options);
      }
export function useGetInternalUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInternalUserQuery, GetInternalUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInternalUserQuery, GetInternalUserQueryVariables>(GetInternalUserDocument, options);
        }
export type GetInternalUserQueryHookResult = ReturnType<typeof useGetInternalUserQuery>;
export type GetInternalUserLazyQueryHookResult = ReturnType<typeof useGetInternalUserLazyQuery>;
export type GetInternalUserQueryResult = Apollo.QueryResult<GetInternalUserQuery, GetInternalUserQueryVariables>;